<template>
  <v-flex xs12>
    <v-divider class="mt-3 mb-4" />
    <v-flex>
      <v-layout
        align-center
        justify-content-between
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex class="f-16">
          <p class="mb-0">
            {{ $t('family_card.document_section.specialist_package_instruction.title') }}
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout
        align-center
        justify-content-between
        class="documents-row"
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex
          xs6
          sm6
          md5
          xl4
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <v-layout
            align-center
            wrap
          >
            <v-flex xs12>
              <v-layout align-center>
                <BaseIcon class="mr-2">
                  <FileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                </BaseIcon>
                <p class="mb-0 f-1">
                  <span class="fw-600">
                    {{
                      $t('family_card.document_section.specialist_package_instruction.to_lawyers')
                    }}
                  </span>
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex class="none-growth">
          <v-btn
            v-if="!lawyersReadOnly"
            :to="lawyersLink"
            color="sz_violet"
            class="mx-0"
          >
            {{ $t('buttons.edit') }}
          </v-btn>
          <router-link
            v-else
            :to="lawyersLink"
          >
            {{ $t('buttons.preview') }}
          </router-link>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout
        align-center
        justify-content-between
        class="documents-row"
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex
          xs6
          sm6
          md5
          xl4
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <v-layout
            align-center
            wrap
          >
            <v-flex xs12>
              <v-layout align-center>
                <BaseIcon class="mr-2">
                  <FileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                </BaseIcon>
                <p class="mb-0 f-1">
                  <span class="fw-600">
                    {{
                      $t('family_card.document_section.specialist_package_instruction.to_medics')
                    }}
                  </span>
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex class="none-growth">
          <v-btn
            v-if="!medicsReadOnly"
            :to="medicsLink"
            color="sz_violet"
            class="mx-0"
          >
            {{ $t('buttons.edit') }}
          </v-btn>
          <router-link
            v-else
            :to="medicsLink"
          >
            {{ $t('buttons.preview') }}
          </router-link>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import FileIcon from '@/icons/FileIcon';
import mainPage from '@/mixins/specialistPackage/mainPage';

export default {
    name: 'SpecialistPackageDocumentsList',
    components: { FileIcon, BaseIcon },
    mixins: [mainPage],
    computed: {
        xsScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        buttonTitle () {
            return this.$t('buttons.edit');
        },
        medicsReadOnly () {
            if (this.canEditSpecialistPackage) {
                return !this.medicsPackagePermission;
            }
            return true;
        },
        lawyersReadOnly () {
            if (this.canEditSpecialistPackage) {
                return !this.lawyersPackagePermission;
            }
            return true;
        },
        lawyersLink () {
            return { name: 'specialist-package-lawyers', params: { familyId: this.$route.params.id } };
        },
        medicsLink () {
            return { name: 'specialist-package-medics', params: { familyId: this.$route.params.id } };
        }
    }
};
</script>

<style scoped></style>
